import React, { useEffect, useState } from "react";
import { Button, Select, Spin } from "antd";
import {
  fetchBillV1,
  getBbpsformParamsV1,
  getBbpsOperatorV1,
  payBillV1,
} from "../../../../ApiServices/Apifun";
import {
  dispatchtoast,
  filterOption,
  getLocalStorageItem,
} from "../../../../Utils";
import { BBPS } from "../../../../Assets/BBPS";
import ReportDrawer from "../../../../Common/ReportDrawer";
import Content from "../../../../Common/ReceiptContent";

const CommonBBPSV1 = (props) => {
  const { type, selection } = props;
  const [operators, setOperators] = useState([]);
  const [selectLoading, setSelectLoading] = useState(false);
  const [Btnloading, setBtnLoading] = useState(false);
  const [getFieldsLoader, setGetFieldsLoader] = useState(false);
  const [AllOerators, setAllOperators] = useState([]);
  const [billDetail, setBillDetail] = useState({});
  const [optional, setOptional] = useState("");
  const [selectedOperator, setselectedOperator] = useState(null);
  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
  const [accountId, setAccountId] = useState();
  const [billerId, setBillerId] = useState();
  const [PaybillResult, setPaybillResult] = useState({
    data: null,
    transaction_id: null,
  });
  const [renderField, setRenderField] = useState([]);
  const [disableAmount, setDisableAmount] = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [isfetch, setIsFetch] = useState(0);
  const [disableOperatorField, setDisableOperatorField] = useState(false);
  const [BtnState, setBtnState] = useState("");
  const [fields, setFields] = useState({});
  const [amount, setamount] = useState("");
  const [fetchDate, setFetchDate] = useState("");
  const [fetchEmail, setFetchEmail] = useState("");
  const formatDate = (value) => {
    if (!value) return "";
    const [year, month, day] = value.split("-");
    return `${day}/${month}/${year}`;
  };
  useEffect(() => {
    setBtnState(type === "fasttag" ? "Pay Bill" : "Fetch Bill");
  }, [type]);
  useEffect(() => {
    setOptional("");
    setselectedOperator(null);
    setOperators([]);
    setRenderField([]);
    setOpenReceiptDrawer(false);
    setPaybillResult({ data: null, transaction_id: null });
    setamount("");
    setBillDetail({});
    setDisableOperatorField(false);
    setBtnLoading(false);
    setDisableAmount(false);
    setSelectLoading(false);
    setShowDetail(false);
    setFields({});
    setGetFieldsLoader(false);
    setAllOperators({});
    setAccountId();
  }, [selection]);

  const getAllOperators = () => {
    setSelectLoading(true);
    setDisableOperatorField(true);
    getBbpsOperatorV1(type)
      .then((res) => {
        if (res.status) {
          setAllOperators(res.data);
          if (type == "fasttag") {
            setOperators(
              res.data.map(
                (
                  item,
                  index, //need to check this
                ) => {
                  return {
                    label: item.billerName,
                    code: item.code,
                    value: item.optional,
                    key: index,
                  };
                },
              ),
            );
          } else {
            setOperators(
              res.data.map(
                (
                  item,
                  index, //need to check this
                ) => {
                  return {
                    label: item.billerName,
                    value: item.code,
                    key: index,
                  };
                },
              ),
            );
          }
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setSelectLoading(false);
        setDisableOperatorField(false);
      });
  };
  console.log(operators, "operators");
  useEffect(() => {
    getAllOperators();
  }, [type]);
  useEffect(() => {
    if (selectedOperator) {
      const checktype = AllOerators.find(
        (item) => item.code === selectedOperator,
      )?.is_fetch;

      setIsFetch(checktype);

      if (type === "fasttag") {
        setBtnState("Pay Bill");
      } else {
        setBtnState(checktype === 1 ? "Pay Bill" : "Fetch Bill");
      }
    }
  }, [selectedOperator, type, AllOerators]);
  const handleChange = (event, type, min, max) => {
    const { value, name } = event.target;
    let changable;
    if (type === "NUMERIC") {
      // Use a regular expression to allow only numbers
      changable = value.replace(/[^0-9]/g, "");
    } else {
      changable = value;
    }
    // Apply the min and max length limits
    const limitedNumbers = changable.slice(0, max);

    // Update the state with the sanitized value
    setFields({ ...fields, [name]: limitedNumbers });
  };

  const handeBtnSubmit = () => {
    setBtnLoading(true);
    setDisableOperatorField(true);
    if (BtnState === "Fetch Bill" && type !== "fasttag") {
      const formdata = new FormData();
      formdata.append("biller_id", selectedOperator);
      formdata.append("account_id", accountId);
      if (type == "insurance") {
        formdata.append("dob", formatDate(fetchDate));
        formdata.append("email", fetchEmail);
      }
      Object.entries(fields).map(([key, value], index) =>
        formdata.append(key, value),
      );
      fetchBillV1(formdata, type)
        .then((res) => {
          if (res.status) {
            setShowDetail(true);
            setBillDetail(res.data);
            setamount(res.data.amount);
            setBtnState("Pay Bill");
            setDisableAmount(true);
          }
        })
        .catch((err) => console.log(err))
        .finally(() => {
          setBtnLoading(false);
          setDisableOperatorField(false);
        });
    } else {
      const data = renderField.reduce((a, b) => {
        a = { ...a, [b.paramName]: fields[b.fieldKey] };
        return a;
      }, {});

      const formdata = new FormData();

      if (type == "fasttag") {
        formdata.append("optional", optional);
      }
      formdata.append("biller_id", selectedOperator);
      formdata.append("amount", amount);
      formdata.append("account_id", accountId);
      formdata.append("form_data", JSON.stringify(data));
      formdata.append("due_date", billDetail?.due_date);
      formdata.append("account_holder_name", billDetail?.account_holder_name);
      formdata.append("latitude", getLocalStorageItem("latitude"));
      formdata.append("longitude", getLocalStorageItem("longitude"));
      formdata.append(
        "biller_name",
        AllOerators.filter((item, index) => item?.code === selectedOperator)[0]
          ?.billerName,
      );
      Object.entries(fields).map(([key, value], index) =>
        formdata.append(key, value),
      );
      payBillV1(formdata, type)
        .then((res) => {
          if (res.status) {
            setPaybillResult({
              data: {
                "Biller Name": res.data.biller_name,
                Amount: res.data.amount,
                "Member Name.": res.data?.account_holder_name ?? "-",
                "Payment Status":
                  res.data.payment_status === 2
                    ? "Failed"
                    : res.data.payment_status === 0
                      ? "Pending"
                      : "Success",
              },
              transaction_id: res.data.transaction_id,
            });
            setOpenReceiptDrawer(true);
          }
        })
        .catch((err) => console.log(err))
        .finally(() => {
          setBtnLoading(false);
          setDisableOperatorField(false);
        });
    }
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 w place-items-start gap-3">
        <Spin spinning={getFieldsLoader}>
          <div className="prepaid bg-white w-full shadow-normal rounded-3xl   p-5">
            <div className="flex justify-between items-center">
              <p className="font-bold capitalize text-[15px] mb-2">
                {type} Payment
              </p>
              <BBPS />
            </div>
            <Spin spinning={selectLoading}>
              <div className="selectionFields ">
                <div>
                  <p className={`required text-textGray mb-2`}>
                    Select Operator
                  </p>
                  <Select
                    showSearch
                    placeholder="Select an operator"
                    filterOption={filterOption}
                    value={type == "fasttag" ? optional : selectedOperator}
                    loading={selectLoading}
                    disabled={disableOperatorField}
                    onChange={(val, data) => {
                      if (type == "fasttag") {
                        setOptional(val);
                        setselectedOperator(data?.code);
                      } else {
                        setselectedOperator(val);
                      }

                      setShowDetail(true);
                    }}
                    className="w-full mb-2 "
                    options={operators}
                  />
                </div>
                {/* {renderField.length !== 0
                  ? renderField.map((item, index) => {
                      return (
                        <div key={index}>
                          <p
                            className={`required capitalize text-textGray mt-2 text-xs mb-2`}
                          >
                            {item.paramName}
                          </p>
                          <input
                            name={item?.fieldKey}
                            value={fields[item?.fieldKey]}
                            placeholder={`Enter ${item.paramName}`}
                            minLength={Number(item?.minlength)}
                            max={Number(item?.maxlength)}
                            disabled={disableOperatorField}
                            onChange={(e) =>
                              handleChange(
                                e,
                                item.datatype,
                                item.minlength,
                                item.maxlength
                              )
                            }
                            type="text"
                            className="outline-none text-xs border w-full border-gray-200 focus:border-primary h-9 px-2 "
                          />
                        </div>
                      );
                    })
                  : ""} */}
                {selectedOperator && (
                  <>
                    <div
                    // className={`${
                    //   isfetch ===  &&
                    //   type !== "fasttag" &&
                    //   BtnState === "Fetch Bill"
                    //     ? "hidden"
                    //     : "block"
                    // }`}
                    >
                      {/* <p className={`required capitalize text-textGray mb-2`}>
                      Biller Id
                    </p>
                    <input
                      value={billerId}
                      min={1}
                      disabled={disableAmount && type !== "fasttag"}
                      onChange={(e) => setBillerId(e.target.value)}
                      type="number"
                      className="outline-none text-xs border w-full border-gray-200 focus:border-primary  h-9 px-2 "
                    /> */}
                      <p className={`required capitalize text-textGray mb-2`}>
                        Account Id
                      </p>
                      <input
                        value={accountId}
                        type={type === "fasttag" ? "text" : "number"}
                        disabled={disableAmount && type !== "fasttag"}
                        onChange={(e) => {
                          const value =
                            type === "fasttag"
                              ? e.target.value.replace(/[^a-zA-Z0-9]/g, "")
                              : e.target.value;

                          setAccountId(value);
                        }}
                        className="outline-none text-xs border w-full border-gray-200 focus:border-primary h-9 px-2"
                      />
                    </div>
                    {type == "insurance" && (
                      <>
                        <div>
                          <p
                            className={`required capitalize text-textGray mb-2`}
                          >
                            DOB
                          </p>
                          <input
                            value={fetchDate}
                            disabled={disableAmount && type !== "fasttag"}
                            onChange={(e) => setFetchDate(e.target.value)}
                            type="date"
                            className="outline-none text-xs border w-full border-gray-200 focus:border-primary  h-9 px-2 "
                          />
                        </div>
                        <div>
                          <p
                            className={`required capitalize text-textGray mb-2`}
                          >
                            Email
                          </p>
                          <input
                            value={fetchEmail}
                            disabled={disableAmount && type !== "fasttag"}
                            onChange={(e) => setFetchEmail(e.target.value)}
                            type="email"
                            className="outline-none text-xs border w-full border-gray-200 focus:border-primary  h-9 px-2 "
                          />
                        </div>
                      </>
                    )}
                  </>
                )}
                {selectedOperator && (
                  <div
                    className={`${
                      // isfetch === 1 &&
                      type !== "fasttag" && BtnState === "Fetch Bill"
                        ? "hidden"
                        : "block"
                    }`}
                  >
                    <p className={`required capitalize text-textGray mb-2`}>
                      Amount
                    </p>
                    <input
                      value={amount}
                      min={1}
                      disabled={disableAmount && type !== "fasttag"}
                      onChange={(e) => setamount(e.target.value)}
                      type="number"
                      className="outline-none text-xs border w-full border-gray-200 focus:border-primary  h-9 px-2 "
                    />
                  </div>
                )}
                {showDetail && Object.keys(billDetail).length !== 0 && (
                  <div className="grid mt-2 grid-cols-1 border border-primary p-2 rounded-md font-medium text-xs bg-bsgray300 sm:grid-cols-2 gap-2 place-items-start">
                    <p>
                      Name :{" "}
                      {billDetail.account_holder_name
                        ? billDetail.account_holder_name
                        : "-"}
                    </p>
                    {type !== "fasttag" ? (
                      <>
                        <p>
                          Amount : {billDetail.amount ? billDetail.amount : "-"}{" "}
                          Rs.
                        </p>
                        <p>
                          Bill Date :{" "}
                          {billDetail.bill_date ? billDetail.bill_date : "-"}
                        </p>
                        <p>
                          Due Date :{" "}
                          {billDetail.due_date ? billDetail.due_date : "-"}
                        </p>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            </Spin>
            {selectedOperator && (
              <div className="mt-2">
                <Button
                  disabled={Object.values(fields).some((value) => value === "")}
                  loading={Btnloading}
                  onClick={handeBtnSubmit}
                  className="bg-primary w-full border-none rounded-md h-9 text-center text-white flex justify-center items-center font-bold text-md cursor-pointer"
                >
                  {/* {isFetch === 1 ? "Fetch Bill" : "Pay Bill"} */}
                  {BtnState}
                </Button>
              </div>
            )}
          </div>
        </Spin>
      </div>
      {openReceiptDrawer && (
        <ReportDrawer
          title={"Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          content={<Content data={PaybillResult} />}
        />
      )}
    </>
  );
};

export default CommonBBPSV1;
